<!--
  Component: MetricValueList, MetricValueListCount, MetricValueListNotSafe

  This component creates a list of value + label rows based on matching slots
  in the metadata.

  MetricValueList - places value before the label
  MetricValueListCount - places value in parenthesis after the label
  MetricValueListNotSafe - places value before the label and displays row label with
    html embedded, so not safe for database values that may be supplied by user
    - i.e. HTML-formatted text values are allowed

  Notes:
  - Should be paired so part after the prefixes match between labels and values
  - Loops through list of values (in metadata order, not re-sorted) to search
    for suffixes to match on, since labels are optional
  - If matching label slot exists, uses the value from that label slot's data
    as the label; otherwise display_text of value slot is used as label
-->
<template>
  <ul :class="['metric-value-list',hasSomeValues?'':'no-values']">
    <li v-if="!hasSomeValues" class="value-row"><span class="value">N/A</span></li>
    <li class="value-row"
      v-for="d in valueSlotData"
      :key="d.component_slot"
      v-if="hasValueForSlot(d)"
      >
      <span class="value">{{rowDispValueForSlot(d)}}</span>
      <span v-if="isNotSafe" v-html="rowDispLabelForValueSlot(d)" class="label" />
      <span v-else class="label">{{ rowDispLabelForValueSlot(d) }}</span>
    </li>
  </ul>
</template>

<script>
import Component, { mixins } from 'vue-class-component'

import {MetadataDescMixin} from './metadata-mixin'
/* Prefixes (followed by any string) for Valid Slot Names for this Component */
const SN_VALUE_PREFIX = 'value_'
const SN_LABEL_PREFIX = 'label_'

@Component({
})
export default class MetricValueList extends mixins(MetadataDescMixin) {
  isNotSafe = false
  /* Getters */
  get valueSlotData () {
    return this.slotDataForPrefix(SN_VALUE_PREFIX)
  }
  get hasSomeValues () {
    return this.valueSlotData.some(d => this.hasValueForSlot(d))
  }

  /* Methods - utility */
  labelForValueSlot (slotData) {
    const valueSlotName = slotData.component_slot
    const labelSlotName = valueSlotName.replace(SN_VALUE_PREFIX, SN_LABEL_PREFIX)
    return this.hasSlotName(labelSlotName) ? this.dispValueForSlotName(labelSlotName)
      : this.displayTextForSlotName(valueSlotName)
  }

  rowDispValueForSlot (slotData) {
    return this.dispValueForSlot(slotData)
  }
  rowDispLabelForValueSlot (slotData) {
    const labelData = this.labelForValueSlot(slotData)
    return this.descReplaceValues(labelData)
  }
}

@Component({
})
class MetricValueListNotSafe extends MetricValueList {
  isNotSafe = true
}

@Component({
})
class MetricValueListCount extends MetricValueList {
  /* Override text behavior to put value in parenthesis */
  rowDispValueForSlot (slotData) {
    return ''
  }
  rowDispLabelForValueSlot (slotData) {
    return `${this.labelForValueSlot(slotData)} (${this.dispValueForSlot(slotData)})`
  }
}
export { MetricValueList, MetricValueListCount, MetricValueListNotSafe }

</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.metric-value-list {
  margin-block-start: 0.5em;
  -webkit-padding-start: 0px;
  padding-left: 0px; /* for IE */
}
.value-row {
  display: flex;
  .value {
    width: 44px;
    text-align: right;
    padding-right: 14px;
  }
  .label {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2025/tab-mods/MetricValueList.vue